import { formatPeriodLabel } from '../modules/submissions/periodFormat';

// fields: report_fields rows ({id,label,sort_order}); content: report_content
// rows ({report_field_id, value}). Returns answered fields in sort order.
export function mergeReportContent(fields, content) {
  const byId = (content || []).reduce((m, r) => ({ ...m, [r.report_field_id]: r.value }), {});
  return [...(fields || [])]
    .filter((f) => byId[f.id] != null && byId[f.id] !== '')
    .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0))
    .map((f) => ({ id: f.id, label: f.label, value: byId[f.id], sortOrder: f.sort_order || 0 }));
}

// row: a listApprovedReports submission row; mergedFields: mergeReportContent output.
export function normalizeReportForExport(row, mergedFields) {
  return {
    submitter: row.submitter?.name || '',
    email: row.submitter?.email || '',
    period: formatPeriodLabel(row.period, row.period_start, row.period_end),
    systemName: row.report_systems?.name || '',
    status: row.status || '',
    submittedAt: row.submitted_at || '',
    approvedBy: row.reviewer?.name || '',
    teamLead: row.submitter?.team_lead?.name || '',
    country: row.countries?.name || row.submitter?.countries?.name || '',
    reviewComment: row.review_comment || '',
    fields: mergedFields || [],
  };
}

const META = [
  ['Submitter', 'submitter'], ['Email', 'email'], ['Period', 'period'],
  ['Report System', 'systemName'], ['Status', 'status'], ['Submitted at', 'submittedAt'],
  ['Approved by', 'approvedBy'], ['Team Lead', 'teamLead'], ['Country', 'country'],
  ['Review comment', 'reviewComment'],
];

// Vertical single-report CSV rows: metadata block, blank, Field/Value table.
export function buildSingleReportRows(report) {
  const rows = META.map(([label, key]) => [label, report[key]]);
  rows.push([]);
  rows.push(['Field', 'Value']);
  report.fields.forEach((f) => rows.push([f.label, f.value]));
  return rows;
}

// Wide combined CSV: one row per report; field-label columns unioned (first-seen).
export function buildCombinedReportRows(reports) {
  const labels = [];
  const seen = new Set();
  reports.forEach((r) => r.fields.forEach((f) => { if (!seen.has(f.label)) { seen.add(f.label); labels.push(f.label); } }));
  const metaLabels = META.map(([label]) => label);
  const header = [...metaLabels, ...labels];
  const body = reports.map((r) => {
    const byLabel = r.fields.reduce((m, f) => ({ ...m, [f.label]: f.value }), {});
    return [...META.map(([, key]) => r[key]), ...labels.map((l) => (byLabel[l] != null ? byLabel[l] : ''))];
  });
  return [header, ...body];
}

const slug = (s) => String(s || '').replace(/[^a-z0-9]+/gi, '-').replace(/^-+|-+$/g, '').toLowerCase() || 'report';
export function reportFilename(report) { return `report-${slug(report.submitter)}-${slug(report.period)}.csv`; }
export function combinedFilename(filters) {
  const key = filters?.dateKey === 'custom' ? `${filters.customFrom || ''}_${filters.customTo || ''}` : (filters?.dateKey || 'all');
  return `reports-${slug(key)}.csv`;
}
